import type { PriceListSetDefaultResponseType } from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePriceListSetDefault = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: ({ id }: { id: number }) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `price-lists/${id}/set-default`,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as PriceListSetDefaultResponseType,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.ProductPriceTiersLegacy],
      });
    },
  });
};
